import { Box, Button, Checkbox, Stack } from '@mui/material'
import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { makePostRequest } from 'utils/api'
import { makeGetRequest } from 'utils/api'

export default function Aspect({ appUser, setAppUser, handleClose, fetchUser }) {
  const [aspectList, setAspectList] = React.useState([])
  const [selected, setSelected] = React.useState(0)

  useEffect(() => {
    if (appUser?.user_parameter?.aspect) {
      setSelected(appUser?.user_parameter?.aspect)
    }
    getAspect()
  }, [])
  const getAspect = async () => {
    const response = await makeGetRequest('/api/base/app-aspect/', {}, true)
    if (response.status === 200) {
      setAspectList(response.data)
      if (response.data.length === 1) {
        setSelected(response.data[0].id)
      }
    }
  }
  const { handleSubmit } = useForm({
    defaultValues: {},
  })
  const onSubmit = async (data) => {
    if (selected === 0) {
      alert('Please select any aspect.')
      return
    }
    let payload = {
      aspect: selected,
    }

    const response = await makePostRequest('/api/user/update-aspect/', payload, {}, true)
    if (response.status === 200) {
      alert('Update successfull')
      fetchUser()
      // handleClose()
    }
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ height: '100%' }}>
      <Box className="sdf" display={'flex'} flexDirection={'column'} height={'100%'}>
        <Box sx={{ width: '100%' }} className="hel">
          <Box sx={{ background: '#001B42', p: 3, display: 'flex', alignItems: 'center' }}>
            <Box ml={2} color={'white'}>
              Aspect
            </Box>
          </Box>
          <Box paddingX={4}>
            {aspectList.map((e) => (
              <Box key={e.id} paddingY={1} sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ height: 90, width: 170, borderRadius: 5 }}>
                  <img style={{ height: '100%', borderRadius: 7 }} src={e.picture} alt={e.name} />
                </Box>
                <Box pl={5} sx={{ fontWeight: '700' }} mr={'auto'}>
                  {e.name}
                </Box>
                <Box>
                  <Checkbox
                    sx={{ ml: 'auto', '.PrivateSwitchBase-input': { display: 'none' } }}
                    name="aspect"
                    onClick={() => setSelected(e.id)}
                    checked={selected === e.id ? true : false}
                  />
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
        <Box sx={{ marginTop: 'auto', background: '#001B42', py: 1, pr: 2 }}>
          <Stack spacing={2} direction="row" justifyContent={'flex-end'}>
            <Button type="submit" variant="text" sx={{ color: 'white', textTransform: 'none' }}>
              Sauvegarder
            </Button>
            <Button
              variant="text"
              sx={{ color: 'white', textTransform: 'none' }}
              onClick={handleClose}
            >
              Interrompre
            </Button>
          </Stack>
        </Box>
      </Box>
    </form>
  )
}
